module.exports = __webpack_public_path__ + "static/media/19.9048efb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/19.jpg
// module id = 388
// module chunks = 0